export default __webpack_public_path__ + "static/media/Add_new_wine-square.2bc3e5e5.svg";